import ApiAsset, {
    AssetContentFormat,
    AssetContent as ApiAssetContent
} from "../api/model/snapshots/Asset";
import BasicRecord from "../utils/BasicRecord";
import { ImageLightness } from "../utils/image";

enum AssetStatState {
    loading = "loading",
    empty = "empty",
    ready = "ready",
    optimizing = "optimizing",
}

type AssetPercent = {
    type: AssetContentFormat;
    diff: number;
};

interface AssetContent extends Omit<ApiAssetContent, "optimized"> {
    url: string;
    density: string;
    densityScale: number;
    optimized?: Partial<AssetContent> | null; // TODO: Change this to `optimizedContent` object and keep the original `optimized` type
}

interface Asset extends Omit<ApiAsset, "contents"> {
    _id: string;
    density: string;
    densityScale: number;
    contents: AssetContent[];
    statState?: AssetStatState;
    lightness?: ImageLightness;
    localName?: string;
    percent?: AssetPercent;
    size?: {
        width: number;
        height: number;
    };
}

interface DownloadableAsset extends Asset {
    size: {
        width: number;
        height: number;
    };
}

/** Transformed Asset */

interface AssetFormatVariant {
    _id: string;
    url: string;
    densityScale: number;
    optimized?: Partial<AssetContent> | null;
    assetId?: string;
}

interface AssetFormatDiff {
    type: AssetContentFormat;
    percent: number;
}

interface AssetFormat {
    variants: AssetFormatVariant[];
    diff?: AssetFormatDiff;
}

type AssetFormats = Record<AssetContentFormat, AssetFormat>;

type TransformedAsset = {
    id: string;
    formats: AssetFormats;
    statState?: AssetStatState;
    previewImages: BasicRecord;
    layerName: string;
    displayName: string;
    localName?: string;
    autoExported?: boolean;
    percent?: AssetPercent;
    light?: boolean;
    size?: {
        width: string;
        height: string;
    };
};

export default Asset;
export {
    AssetContent,
    AssetFormatDiff,
    TransformedAsset,
    AssetFormats,
    AssetFormatVariant,
    DownloadableAsset,
    AssetStatState,
    AssetPercent
};
